import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getOrderDetail as getOrderDetailApi,
    updateOrderItem as updateOrderItemApi,
    deleteOrderItem as deleteOrderItemApi,
    addOrderItem as addOrderItemApi,
} from "../../helpers/backend_helper";

export interface DraftOrderItemPayload {
    itemId: string | number;
    quantity?: number;
    note?: string;
    options?: any;
}

export interface AddDraftOrderItemPayload {
    orderId: string | number;
    item: {
        id: string | number;
        quantity: number;
        note?: string;
        option?: any;
        price?: number;
        productName?: string;
    };
}

export const fetchDraftOrderDetail = createAsyncThunk(
    "draftOrderDetails/fetch",
    async (orderId: string | number) => {
        const response = await getOrderDetailApi(orderId);
        return { orderId, data: response?.data };
    },
);

export const updateDraftOrderItem = createAsyncThunk(
    "draftOrderDetails/updateItem",
    async (
        {
            orderId,
            itemId,
            data,
        }: {
            orderId: string | number;
            itemId: string | number;
            data: { quantity?: number; note?: string; options?: any };
        },
    ) => {
        await updateOrderItemApi(orderId, itemId, data);
        const response = await getOrderDetailApi(orderId);
        return { orderId, data: response?.data };
    },
);

export const removeDraftOrderItem = createAsyncThunk(
    "draftOrderDetails/removeItem",
    async ({ orderId, itemId }: { orderId: string | number; itemId: string | number }) => {
        await deleteOrderItemApi(orderId, itemId);
        const response = await getOrderDetailApi(orderId);
        return { orderId, data: response?.data };
    },
);

export const addDraftOrderItem = createAsyncThunk(
    "draftOrderDetails/addItem",
    async ({ orderId, item }: AddDraftOrderItemPayload) => {
        await addOrderItemApi(orderId, {
            menu_item_id: item.id,
            quantity: item.quantity,
            note: item.note,
            options: item.option,
        });
        const response = await getOrderDetailApi(orderId);
        return { orderId, data: response?.data };
    },
);
